import { withTranslation } from 'server/i18n'
import PropTypes from 'prop-types'
import { NextSeo } from 'next-seo'
import { Box } from 'reflexbox'
import getConfig from 'next/config'

import PageTitle from 'components/PageTitle'
import InquiryForm from 'components/InquiryForm'

import layoutTheme from 'theme/layout-theme'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL, DOMAIN_ROOT } = publicRuntimeConfig

const InquiryPage = ({ canonical, t, i18n, type }) => {
    const seoData = {
        title: `${t('meta-data:inquiry-title')} | Merk & Merk`,
        description: t('meta-data:inquiry-description'),
        canonical: t('meta-data:inquiry-url'),
        openGraph: {
            title: `${t('meta-data:inquiry-title')} | Merk & Merk`,
            description: t('meta-data:inquiry-description'),
            url: t('meta-data:inquiry-url'),
            images: [
                {
                    url: `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                }
            ]
        },
        languageAlternates: [
            {
                hrefLang: 'en',
                href: `${DOMAIN_ROOT}/inquiry`
            },
            {
                hrefLang: 'de',
                href: `${DOMAIN_ROOT}/de/inquiry`
            }
        ]
    }

    return (
        <div>
            <NextSeo {...seoData} />

            <Box
                theme={layoutTheme}
                px={40}
                mt={[35, null, 70, 100, 150]}
                mb={[35, null, 70, 80]}
                maxWidth={1480}
                mx="auto">
                <PageTitle
                    title={t('inquiry-page:page-title')}
                    subtitle={t('inquiry-page:page-subtitle')}
                    lead={t('inquiry-page:page-lead')}
                    titleTag="h1"
                    subtitleTag="h2"
                />
            </Box>

            <Box theme={layoutTheme} px={20} maxWidth={1440} mx="auto" mb={[80, null, null, 150, 250]}>
                <InquiryForm type={type} showDryMarinaVodice />
            </Box>
        </div>
    )
}

InquiryPage.getInitialProps = async ({ query, req: { i18n } = {} }) => ({
    type: query.type,
    canonical: i18n ? i18n.getFixedT('en')('meta-data:inquiry-url') : undefined,
    namespacesRequired: ['common', 'inquiry-page', 'meta-data']
})

InquiryPage.propTypes = {
    canonical: PropTypes.string,
    t: PropTypes.func.isRequired,
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    type: PropTypes.string
}

InquiryPage.defaultProps = {
    canonical: undefined,
    type: undefined
}

export default withTranslation(['common', 'inquiry-page', 'meta-data'])(InquiryPage)
